import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NoElementComponent } from './components/no-element/no-element.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UplDocBtnComponent } from './components/upl-doc-btn/upl-doc-btn.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { DocumentsCardComponent } from './components/documents/documents-card/documents-card.component';
import { TitleComponent } from './components/title/title.component';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { TableLegendComponent } from './components/table-legend/table-legend.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { TableNonConformitaOrdineComponent } from '../pages/ordini/dettaglioOrdine/components/table-non-conformita-ordine/table-non-conformita-ordine.component';

@NgModule({
  declarations: [
    UplDocBtnComponent,
    NoElementComponent,
    TitleComponent,
    ConfirmDialogComponent,
    DocumentsComponent,
    DocumentsCardComponent,
    SearchPanelComponent,
    TableLegendComponent,
    PaginatorComponent,
    TableNonConformitaOrdineComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    TranslateModule,
    UplDocBtnComponent,
    NoElementComponent,
    TitleComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UplDocBtnComponent,
    ConfirmDialogComponent,
    DocumentsComponent,
    DocumentsCardComponent,
    SearchPanelComponent,
    TableLegendComponent,
    PaginatorComponent,
    TableNonConformitaOrdineComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
